import React, {useState} from "react";
import {UIText} from "../../../components/ui/text.js";
import {FormElement} from "../../../helpers/form/element.js";
import {isEmail} from "../../../helpers/form/validation.js";
import {UIButton} from "../../../components/ui/button/button.js";
import {ReactComponent as ArrowLeftSvg} from "../../../assets/icons/arrow_left.svg";
import styles from '../../../assets/variables.scss';
import {UILinkInternal} from "../../../components/ui/link/internal.js";
import { useForm } from '../../../helpers/form/use_form.js';
import { UIInput } from '../../../components/ui/input/input.js';
import {ModelAuthPasswordRecovery} from '../../../model/auth/password-recovery.js';

const ViewAuthForgotPassword = function (props) {

    const Form = useForm(props.resetForm);
    const [success, setSuccess] = useState(false);

    const submitForm = () => {
        if(Form.validate()){
            
            ModelAuthPasswordRecovery.createItem(Form.getProcessedValues(), 
                () => { setSuccess(true); },
                (error) => { Form.setError('email', error) }
            );

        }
    }

    return <div style={{display: 'flex', alignItems: 'center', height: '100%', paddingTop: '71px'}}>
        <div style={{maxWidth: 400, margin: 'auto', width: 400, padding: '0 15px'}}>

            {success?
                <>
                    <UIText type={'head-1'} color={'darkColor'} style={{marginBottom: 10}}>
                        Reset URL sent
                    </UIText>
                    <UIText type={'body-L'} color={'mediumColor'}>
                        We sent a reset URL to your email address. Follow the link in the email to reset your 
                        password. The link will expire after 24 hours.
                    </UIText>
                </>:
                <>

                    <UIText type={'body-L-bold'} color={'mediumColor'} style={{marginBottom: '30px'}}>
                        <UILinkInternal page="sign-in">
                            <ArrowLeftSvg style={{
                                        color: styles.darkColor, 
                                        marginRight: 5, 
                                        verticalAlign: 'middle'
                                    }}/> 
                            &nbsp;Cancel
                        </UILinkInternal>
                    </UIText>

                    <UIText type={'head-1'} color={'darkColor'} style={{marginBottom: 10}}>
                        Forgot password
                    </UIText>

                    <UIText type={'body-L'} color={'mediumColor'}>
                        Please enter your email address to reset your password.
                    </UIText>

                    <div style={{margin: '25px 0'}}>

                        <Form.Component>
                            {props.resetForm.map((item) => (
                                <FormElement key={item.name} {...item} onEnter={submitForm} />
                            ))}
                        </Form.Component>

                    </div>

                    <UIButton className="primary" style={{width: '100%'}} onClick={submitForm}>
                        Send reset link
                    </UIButton>

                    <UIText type={'body-L'} color={'primaryColor'} style={{padding: 10, textAlign: 'center'}}>
                        <UILinkInternal page="sign-in">Sign in &gt;</UILinkInternal>
                    </UIText>
                </>
            }
        </div>
    </div>
};

ViewAuthForgotPassword.defaultProps = {
    resetForm: [
        {
            title: 'Email address',
            name: 'email',
            element: UIInput,
            type: 'wide',
            required: true,
            validations: [
                {
                    checkValue: isEmail,
                    message: 'Email is not valid'
                }
            ]
        }
    ]
}

export {ViewAuthForgotPassword}